<template>
  <sidenav :custom_class="color" :class="[isRTL ? 'fixed-end' : 'fixed-start']" v-if="showSidenav && !$route.meta.hideLayout" />
  <main class="main-content position-relative max-height-vh-100 h-100">
    <!-- nav -->
    <navbar :class="[isNavFixed ? navbarFixed : '', isAbsolute ? absolute : '']"
      :color="isAbsolute ? 'text-white opacity-8' : ''" :minNav="false" v-if="showNavbar && !$route.meta.hideLayout" />
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component
          :is="Component"
          v-if="$route.meta.keepAlive"
          :key="$route.fullPath"
        />
      </keep-alive>
      <component
        :is="Component"
        v-if="!$route.meta.keepAlive"
        :key="$route.fullPath"
      />
    </router-view>
    <Toast />
    <GoogleDriveErrorModal />

    <!-- <app-footer v-show="showFooter" /> -->
    <configurator :toggle="toggleConfigurator" :class="[showConfig ? 'show' : '', hideConfigButton ? 'd-none' : '']" />
  </main>
</template>
<script>
import Sidenav from "./examples/Sidenav";
import Configurator from "@/examples/Configurator.vue";
import Navbar from "@/examples/Navbars/Navbar.vue";
import Toast from 'primevue/toast';
import GoogleDriveErrorModal from "@/components/GoogleDriveErrorModal.vue";

import { mapMutations, mapState } from "vuex";

export default {
  name: "App",
  components: {
    Sidenav,
    Configurator,
    Navbar,
    Toast,
    GoogleDriveErrorModal
  },
  methods: {
    ...mapMutations(["toggleConfigurator", "navbarMinimize"])
  },
  computed: {
    ...mapState([
      "isRTL",
      "color",
      "isAbsolute",
      "isNavFixed",
      "navbarFixed",
      "absolute",
      "showSidenav",
      "showNavbar",
      "showFooter",
      "showConfig",
      "hideConfigButton"
    ])
  },
  beforeMount() {
    this.$store.state.isTransparent = "bg-transparent";

    const sidenav = document.getElementsByClassName("g-sidenav-show")[0];

    if (window.innerWidth > 1200) {
      sidenav.classList.add("g-sidenav-pinned");
    }
  }
};
</script>

<style>
/* ===================================
   Add this to App.vue <style> (NOT scoped)
   =================================== */

/* Force prevent horizontal scroll everywhere */
html {
  overflow-x: hidden !important;
  max-width: 100vw !important;
  width: 100vw !important;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  overflow-x: hidden !important;
  max-width: 100vw !important;
  width: 100vw !important;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  overflow-x: hidden !important;
  max-width: 100vw !important;
  width: 100vw !important;
  box-sizing: border-box;
}

/* Fix all potential overflow sources */
* {
  box-sizing: border-box;
}

/* Main content area */
.main-content {
  overflow-x: hidden !important;
  max-width: 100%;
}

/* Containers */
.container,
.container-fluid {
  max-width: 100% !important;
  padding-left: 1rem !important;
  padding-right: 1rem !important;
  box-sizing: border-box;
}

/* Rows */
.row {
  margin-left: 0 !important;
  margin-right: 0 !important;
  max-width: 100%;
}

/* Page header (for login/signup pages) */
.page-header {
  overflow-x: hidden !important;
  max-width: 100vw !important;
  width: 100vw !important;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Navbar */
.navbar {
  max-width: 100% !important;
  overflow-x: hidden !important;
}

/* Sidebar layout */
.g-sidenav-show {
  overflow-x: hidden !important;
  max-width: 100vw !important;
}

@media (min-width: 1200px) {
  .g-sidenav-show.g-sidenav-pinned .main-content {
    max-width: calc(100vw) !important;
  }
}

/* DataTable */
.p-datatable-wrapper {
  overflow-x: auto !important;
  max-width: 100%;
}

/* Cards */
.card {
  max-width: 100%;
  box-sizing: border-box;
}

/* Course-session rescheduling dialog */
.swal2-popup.reschedule-swal {
  width: min(36rem, calc(100vw - 2rem));
  padding: 2rem;
  border-radius: 1rem;
}

.reschedule-swal .swal2-html-container {
  margin: 1rem 0 0;
}

.reschedule-dialog {
  color: #344767;
  text-align: right;
}

.reschedule-dialog__intro {
  margin: 0 0 .75rem;
  color: #67748e;
  font-size: .9rem;
  line-height: 1.75;
}

.reschedule-dialog__prompt {
  margin: 0 0 .75rem;
  color: #344767;
  font-size: .875rem;
  font-weight: 700;
}

.reschedule-choices {
  display: grid;
  gap: .75rem;
}

.reschedule-choice {
  display: flex;
  align-items: flex-start;
  gap: .75rem;
  padding: .9rem 1rem;
  margin: 0;
  cursor: pointer;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: .75rem;
  transition: border-color .18s ease, background-color .18s ease, box-shadow .18s ease;
}

.reschedule-choice:hover {
  border-color: #9ac7ef;
  background: #f8fbff;
}

.reschedule-choice.is-selected {
  background: #f0f8ff;
  border-color: #1a73e8;
  box-shadow: 0 0 0 3px rgba(26, 115, 232, .12);
}

.reschedule-choice__input {
  display: grid;
  flex: 0 0 1.25rem;
  width: 1.25rem;
  height: 1.25rem;
  margin-top: .1rem;
  place-items: center;
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  background: #fff;
  border: 2px solid #cbd5e1;
  border-radius: 50%;
  transition: border-color .18s ease, background-color .18s ease;
}

.reschedule-choice__input:checked {
  background: #1a73e8;
  border-color: #1a73e8;
}

.reschedule-choice__input:checked::after {
  width: .42rem;
  height: .42rem;
  content: '';
  background: #fff;
  border-radius: 50%;
}

.reschedule-choice__content,
.reschedule-choice__heading,
.reschedule-choice__description {
  display: block;
}

.reschedule-choice__heading {
  color: #344767;
  font-size: .9rem;
  font-weight: 700;
  line-height: 1.4;
}

.reschedule-choice__description {
  margin-top: .25rem;
  color: #67748e;
  font-size: .8rem;
  line-height: 1.6;
}

.reschedule-choice__badge {
  display: inline-block;
  padding: .15rem .45rem;
  margin-inline-start: .35rem;
  color: #167a35;
  font-size: .67rem;
  font-weight: 700;
  background: #e6f7eb;
  border-radius: 999px;
  vertical-align: middle;
}

.reschedule-choice__input:focus-visible {
  outline: 3px solid rgba(26, 115, 232, .3);
  outline-offset: 2px;
}
</style>
